import { aboutItem } from '@/mocks/homeData';

export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900">
          关于51影院
        </h2>
        <p className="mt-6 md:mt-8 text-sm md:text-base text-foreground-600 leading-relaxed max-w-2xl mx-auto">
          {aboutItem.description}
        </p>
        <div className="mt-8 flex flex-wrap justify-center gap-4 md:gap-6">
          <span className="flex items-center gap-2 text-xs md:text-sm text-foreground-500">
            <i className="ri-checkbox-circle-fill text-primary-500"></i>
            第九影院资源整合
          </span>
          <span className="flex items-center gap-2 text-xs md:text-sm text-foreground-500">
            <i className="ri-checkbox-circle-fill text-primary-500"></i>
            yy影院同步更新
          </span>
          <span className="flex items-center gap-2 text-xs md:text-sm text-foreground-500">
            <i className="ri-checkbox-circle-fill text-primary-500"></i>
            看吧影院精选推荐
          </span>
          <span className="flex items-center gap-2 text-xs md:text-sm text-foreground-500">
            <i className="ri-checkbox-circle-fill text-primary-500"></i>
            九九影院经典专区
          </span>
          <span className="flex items-center gap-2 text-xs md:text-sm text-foreground-500">
            <i className="ri-checkbox-circle-fill text-primary-500"></i>
            18影院影视大全
          </span>
        </div>
      </div>
    </section>
  );
}